import React, { useState } from 'react';
import './PageStyles.css';
import WaitlistModal from '../components/WaitlistModal';

const ForSuppliers = () => {
    const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);

    return (
        <div className="page-container">
            {/* Hero Section */}
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">For Suppliers</h1>
                    <p className="page-hero-subtitle">
                        Showcase your products and connect with qualified buyers. Grow your business by reaching new customers
                        who are actively looking for what you offer.
                    </p>
                    <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                </div>
            </section>

            {/* Value Props Section */}
            <section className="value-props-section">
                <div className="value-props-container">
                    <h2 className="section-title">Why List on Colorkarma Directory?</h2>

                    <div className="value-props-grid">
                        <div className="value-prop-card">
                            <div className="value-prop-icon">👥</div>
                            <h3>Reach Qualified Buyers</h3>
                            <p>
                                Connect with buyers who are actively searching for your products. No more cold outreach—
                                buyers find you when they need what you offer.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">📈</div>
                            <h3>Grow Your Business</h3>
                            <p>
                                Expand your customer base and discover new market opportunities. Access a network of buyers
                                looking for suppliers like you.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">🎨</div>
                            <h3>Showcase Your Products</h3>
                            <p>
                                Create detailed product listings with photos, specifications, and descriptions. Present your
                                offerings in the best light to attract the right buyers.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">⭐</div>
                            <h3>Build Your Reputation</h3>
                            <p>
                                Establish credibility with verified profiles, certifications, and reviews. Build trust with
                                potential buyers before they even reach out.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">🎯</div>
                            <h3>Targeted Exposure</h3>
                            <p>
                                Get matched with buyers who are specifically looking for your products and capabilities.
                                No wasted time on unqualified leads.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">💬</div>
                            <h3>Direct Communication</h3>
                            <p>
                                Communicate directly with interested buyers, answer questions, and build relationships.
                                Streamline your sales process from inquiry to partnership.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section">
                <div className="how-it-works-container">
                    <h2 className="section-title">How It Works for Suppliers</h2>

                    <div className="steps-container">
                        <div className="step-card">
                            <div className="step-number">1</div>
                            <h3>Create Your Profile</h3>
                            <p>Sign up and create a supplier profile with your company information, certifications, and capabilities.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">2</div>
                            <h3>List Your Products</h3>
                            <p>Add detailed product listings with photos, specifications, pricing, and descriptions to showcase your offerings.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">3</div>
                            <h3>Get Discovered</h3>
                            <p>Buyers searching for your products will find you. Our matching system connects you with qualified leads.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">4</div>
                            <h3>Connect & Sell</h3>
                            <p>Respond to inquiries, answer questions, and build relationships with buyers who need your products.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="page-cta-section">
                <div className="page-cta-content">
                    <h2>Ready to Grow Your Business?</h2>
                    <p>Join our waitlist to get early access and start connecting with qualified buyers in your industry.</p>
                    <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                </div>
            </section>
            <WaitlistModal isOpen={isWaitlistModalOpen} onClose={() => setIsWaitlistModalOpen(false)} />
        </div>
    );
};

export default ForSuppliers;

